export default {
  data() {
    return {
      //
      tableHeight: window.innerHeight - 240,
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      total: 0,
      currentPage: 1,
      limit: 20,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      // 表格数据
      signProcessList: [],
      // 弹出层标题
      title: '',
      // 是否显示弹出层
      open: false,
      open1: false,
      // 查询参数
      queryParams: {
        maindjh: undefined,
        hth: undefined,
        settleMode: undefined
      },
      // 表单参数
      form: {},
      statusOptions: [
        {
          dictLabel: '银行承兑汇票',
          dictValue: '银行承兑汇票'

        }, {
          dictLabel: '现金',
          dictValue: '现金'
        }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {

    dateFormat(row, column) {
      if (row.settleDate != null && row.settleDate !== '' && row.settleDate !== undefined) {
        const date = new Date(row.settleDate)
        let d = date.getFullYear() + '-'
        if ((date.getMonth() + 1) < 10) {
          d += '0' + (date.getMonth() + 1)
        } else {
          d += (date.getMonth() + 1)
        }
        d += '-'
        if (date.getDate() < 10) {
          d += '0' + date.getDate()
        } else {
          d += date.getDate()
        }
        return d
      }
    },
    getList() {
      this.loading = true
      const data = {
        currentPage: this.currentPage,
        limit: this.limit,
        maindjh: this.queryParams.maindjh,
        hth: this.queryParams.hth,
        settleMode: this.queryParams.settleMode
      }
      this.$post('/fesback/Financial/purchaseList.z', data).then(request => {
        this.signProcessList = request.data.data
        this.total = request.data.count
        this.loading = false
        this.$message({
          message: request.message,
          type: 'success'
        })
      })
    },
    handleQuery() {
      this.currentPage = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm('queryForm')
      this.queryParams.settleMode = undefined
      this.handleQuery()
    },
    handleSizeChange(val) { // 每页多少条
      this.limit = val
      this.getList()
    },
    handleCurrentChange(val) { // 当前页
      this.currentPage = val
      this.getList()
    }
  }
}
